import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { CaptionService } from "../../../../utils/shared-services/caption.service";
import { AbstractControl, FormBuilder, ValidatorFn, Validators } from "@angular/forms";
import { PriceChangeService } from "../../services/price-change.resource";

@Component({
    selector: "price-explorer-datetime-dialog",
    templateUrl: "./src/app/features/price-change/templates/dialogs/price-explorer-datetime-dialog.html",
    standalone: false
})
export class PriceExplorerDatetimeDialog implements OnInit {

    private formBuilder: FormBuilder = new FormBuilder();
    public captions: Record<string, string>
    public executeMinDate: Date;
    public minTime: string;
    public is24: boolean = true;
    public selectedOption: number = 1;
    public timeFormat: string = '00:00';
    public formGroup = this.formBuilder.group({
        executeDate: [new Date(), Validators.required],
        selectedTime: ['00:00'],
        label: ['']
    });
    public timeObj: string;
    public createNewLabel: boolean = false;
    public priceChangeLabels: any[] = [];


    constructor(
        @Inject(CaptionService) private captionService: CaptionService,
        @Inject(MatDialogRef) public dialogRef: MatDialogRef<PriceExplorerDatetimeDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(PriceChangeService) public priceChangeService: PriceChangeService
    ) {
        this.captions = this.captionService.captions;
        this.executeMinDate = new Date();
        this.executeMinDate.setDate(this.executeMinDate.getDate() - 1);
    }

    ngOnInit(): void {
        const dateObj = this.parseWhen2ExecuteToDate(this.data.when2Execute);
        this.formGroup.get('executeDate').setValue((dateObj));
        this.timeObj = this.parseTimeFromWhen2Execute(this.data.when2Execute);
        this.formGroup.get('selectedTime').setValue((this.timeObj));

        if (this.data.storeRecordsLength != this.data.recordsSelected) {
            this.createNewLabel = true;
            this.updateLabelValidator();
            this.priceChangeService.getPriceChangeLabels(this.data.conceptID).then(labels => {
                this.priceChangeLabels = labels;
                this.updateLabelValidator();
            });
        }
    }

    parseWhen2ExecuteToDate(when2Execute: string): Date {
        return new Date(when2Execute.replace(' ', 'T'));
    }

    parseTimeFromWhen2Execute(when2Execute: string): string {
        const parts = when2Execute.split(' ');
        return parts.length > 1 ? parts[1] : '00:00';
    }

    onExecuteDateChange(newDate: Date) {
        this.formGroup.get('executeDate').setValue(newDate);
        this.formGroup.get('selectedTime').setValue('00:00');
        this.minTime = '00:00';
    }

    onExecuteTimeChange(time: string) {
        this.minTime = time;
    }

    onClose() {
        this.dialogRef.close();
    }

    onSubmit() {
        let formattedTime = this.is24 ? this.formGroup.value.selectedTime : this.convertTo24HourTime(this.formGroup.value.selectedTime);
        const result: any = {
            when2Execute: this.formatDateToYYYYMMDD(this.formGroup.value.executeDate) + ' ' + formattedTime
        };

        // Add label if present and not empty
        const labelValue = this.formGroup.value.label;
        if (labelValue && labelValue.trim() !== '') {
            result.label = labelValue.trim();
        }

        this.dialogRef.close(result);
        // this.dialogRef.close({
        //     when2Execute: this.formatDateToYYYYMMDD(this.formGroup.value.executeDate) + ' ' + formattedTime
        // });
    }

    // Utility method to format time (HH:mm) from when2Execute
    private formatTime(when2Execute: string): string {
        const date = new Date(when2Execute);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    private convertTo24HourTime(time12h: string): string {
        const [time, modifier] = time12h.split(' ');
        let [hours, minutes] = time.split(':').map(Number);
        // Handle the AM/PM modifier
        if (modifier === 'PM' && hours !== 12) {
            hours += 12;
        }
        if (modifier === 'AM' && hours === 12) {
            hours = 0;
        }
        // Format the hours and minutes as a two-digit string
        const hoursStr = hours.toString().padStart(2, '0');
        const minutesStr = minutes.toString().padStart(2, '0');
        return `${hoursStr}:${minutesStr}`;
    }

    private formatDateToYYYYMMDD(date: Date): string {
        let newDate = new Date(date)
        const year = newDate.getFullYear();
        const month = ('0' + (newDate.getMonth() + 1)).slice(-2);
        const day = ('0' + newDate.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }

    onSelectionChange(event: any) {
        const selectedValue = event.value;
        if (selectedValue == 1) {
            this.is24 = true;
            this.timeFormat = this.timeObj;
        } else {
            this.is24 = false;
            this.timeFormat = this.convertTo12HourTime(this.timeObj);
        }
        this.formGroup.get('selectedTime').setValue(this.timeObj);
    }

    convertTo12HourTime(time24: string): string {
        const [hourStr, minuteStr] = time24.split(':');
        let hour = parseInt(hourStr, 10);
        const minutes = minuteStr;
        const ampm = hour >= 12 ? 'pm' : 'am';
        hour = hour % 12 || 12;
        return `${hour}:${minutes} ${ampm}`;
    }

    // Custom validator function
    labelNotDuplicateValidator(labels: any[]): ValidatorFn {
        return (control: AbstractControl) => {
            if (!control.value) return null;
            const exists = labels.some(label => label.displayName?.trim().toLowerCase() === control.value.trim().toLowerCase());
            return exists ? { duplicateLabel: true } : null;
        };
    }


    // Update your updateLabelValidator method:
    updateLabelValidator(): void {
        const labelControl = this.formGroup.get('label');
        if (this.createNewLabel) {
            labelControl?.setValidators([
                Validators.required,
                this.labelNotDuplicateValidator(this.priceChangeLabels)
            ]);
        } else {
            labelControl?.clearValidators();
        }
        labelControl?.updateValueAndValidity();
    }

}


